'use es6';

import PropTypes from 'prop-types';
import ScriptloaderInstallWizardIframe from 'ui-addon-scriptloader/components/ScriptloaderInstallWizardIframe';
import UIModalPanel from 'UIComponents/dialog/UIModalPanel';
import InstallTypes from 'ui-addon-scriptloader/constants/InstallTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const ScriptloaderInstallModalPanel = props => {
  const {
    onConfirm,
    onCloseComplete,
    onOpenComplete,
    onReject,
    showStatus,
    installType
  } = props;
  return /*#__PURE__*/_jsx(UIModalPanel, {
    onCloseComplete: onCloseComplete,
    onOpenComplete: onOpenComplete,
    children: /*#__PURE__*/_jsx(ScriptloaderInstallWizardIframe, {
      onConfirm: onConfirm,
      onReject: onReject,
      showStatus: showStatus,
      installType: installType
    })
  }, "uiScriptloader");
};
ScriptloaderInstallModalPanel.propTypes = {
  installType: PropTypes.oneOf(Object.values(InstallTypes)),
  onConfirm: PropTypes.func.isRequired,
  onCloseComplete: PropTypes.func,
  onOpenComplete: PropTypes.func,
  onReject: PropTypes.func.isRequired,
  showStatus: PropTypes.bool
};
export default ScriptloaderInstallModalPanel;